import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { SelectionBoxComponent } from "../../../components/selectionBox/SelectionBoxComponent";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { setSustainabilityPai } from "@portal/redux/reducers/riskLevelReducer";
import { ISustainabilityProps } from "../types";
import { SetInitialValue } from "../helpers/setInitialValueForSustainability";
import { ChevronCircleButton } from "@portal/components/atoms/buttons/chevronCircle/ChevronCircleButton";

export const PAIInfo = ({ isDefaultLanguage }: ISustainabilityProps) => {
  const dispatch = useAppDispatch();
  const sustainabilityPai = useAppSelector(state => state.persisted.riskLevel).request.sustainabilityPai;
  const [selectedOption, setSelectedOption] = useState<number | null>(SetInitialValue(sustainabilityPai));
  const [isExpanded, setIsExpanded] = useState(false);

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_7_OPTIONS_3_A, texts.PAGE_7_OPTIONS_3_B];

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    if (selectedOption !== null) {
      dispatch(setSustainabilityPai(selectedOption === 0));
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:space-x-3">
      <div className="flex flex-col mt-3 mb-3 bg-white border rounded-lg p-3 sm:w-[60%]">
        <Typography variant="Lead">{texts.PAGE_7_INFO_TEXT_3_HEADER}</Typography>
        <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_3_A}</Typography>

        <div className="flex py-2 justify-center">
          <ChevronCircleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </div>
        {isExpanded && <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_3_B}</Typography>}
      </div>

      <div className="flex sm:w-[40%] w-full">
        <SelectionBoxComponent options={options} selectedOption={selectedOption} onSelectionClick={OnSelectionClick} />
      </div>
    </div>
  );
};
